/**
 * Helper to create brand identifier object based on id and source
 * We need this because the brand can exist in admin and tenant databases with the same id
 * and we need to be able to distinguish between them
 */

export const createBrandIdentifier = (id, source) =>
  id == null || !source ? null : { id: Number(id), source }

export const serializeBrandIdentifier = (brandIdentifier) =>
  brandIdentifier ? JSON.stringify(brandIdentifier) : ''

export const deserializeBrandIdentifier = (serialized) => {
  if (!serialized) {
    return null
  }
  try {
    const parsed = JSON.parse(serialized)
    return createBrandIdentifier(parsed.id, parsed.source)
  } catch {
    return null
  }
}
